"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { PIPELINE_STAGE_COLORS } from "../constants";
import type { PipelineStageData, PipelineStage } from "../types";

interface PipelineStagesChartProps {
  data: PipelineStageData[];
}

const chartConfig = {
  count: { label: "Emails" },
  synced: { label: "Synced", color: PIPELINE_STAGE_COLORS.synced },
  classified: { label: "Classified", color: PIPELINE_STAGE_COLORS.classified },
  crm_processed: { label: "CRM Processed", color: PIPELINE_STAGE_COLORS.crm_processed },
  replied: { label: "Replied", color: PIPELINE_STAGE_COLORS.replied },
};

export function PipelineStagesChart({ data }: PipelineStagesChartProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-medium">Pipeline Stages</CardTitle>
        <p className="text-xs text-muted-foreground">
          Current state of emails received in period
        </p>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[220px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ left: 0, right: 20 }}>
              <CartesianGrid strokeDasharray="3 3" horizontal={false} />
              <XAxis type="number" fontSize={12} />
              <YAxis
                type="category"
                dataKey="label"
                width={110}
                fontSize={12}
                tickLine={false}
              />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Bar dataKey="count" radius={[0, 4, 4, 0]} maxBarSize={28}>
                {data.map((entry) => (
                  <Cell
                    key={entry.stage}
                    fill={PIPELINE_STAGE_COLORS[entry.stage as PipelineStage] ?? "#6b7280"}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
